import { ApiModule } from '@keenvil/littlefinger';
import ApiConfig from '../apiConfig';

/**
 * Guard Module endpoints
 */
class GuardModule extends ApiModule {
  /**
   * Queries the visitors movements lists
   * @param {Object} query filter object.
   *                 Contains q, page, limit, and sort.
   *                 All optionals.
   */
  queryVisitorsMovements(query) {
    return this.adapter.query('guards/accesses', query);
  }

  queryBlacklistMovements(query) {
    return this.adapter.query('guards/accesses', query);
  }

  /**
   * Queries the visitors movements lists
   * @param {Object} query filter object.
   *                 Contains q, page, limit, and sort.
   *                 All optionals.
   */
  downloadVisitorsMovements(query) {
    return this.adapter.query('guards/accesses', query, false);
  }

  openGateWithManualMovement({
    personalId,
    pin,
    gate,
    lane,
    device = 'KEENVIL'
  }) {
    return this.adapter.save('guards/residents/access', {
      device,
      gate,
      lane,
      number: personalId.number,
      pin,
      type: personalId.type
    });
  }

  /**
   * Queries the residents movements lists
   * @param {Object} query filter object.
   *                 Contains q, page, limit, and sort.
   *                 All optionals.
   */
  queryResidentsMovements(query) {
    return this.adapter.query('residents/accesses', query);
  }

  /**
   * Queries the residents movements lists
   * @param {Object} query filter object.
   *                 Contains q, page, limit, and sort.
   *                 All optionals.
   */
  downloadResidentsMovements(query) {
    return this.adapter.query('residents/accesses', query, false);
  }

  /**
   * Queries the residents movements lists
   * @param {Object} query filter object.
   *                 Contains q, page, limit, and sort.
   *                 All optionals.
   */
  queryCurfew(query) {
    return this.adapter.query('guards/accesses/without-exit', query);
  }

  getVehicleMovements(query) {
    return this.adapter.query('lpr/accesses', query);
  }

  /**
   * Queries the vehicle movements lists
   * @param {Object} query filter object.
   *                 Contains page and limit
   *                 All optionals.
   */
  getAllVehicleMovements(query) {
    return this.adapter.query('lpr/accesses', query);
  }

  /**
   * Searches resident matches for a license plate based on the LPR + face
   * recognition matching system.
   * @param {Object} query filter object.
   *                 Expects 'license-plate' and supports 'ocr-mode',
   *                 'include-samples', 'sample-size' and 'min-confidence'.
   */
  getLprPlateMatches(query) {
    return this.adapter.query('lpr/plates/matches', query);
  }

  /**
   * Queries historical LPR + face-recognition plate matches for a set of
   * resident account IDs. POST with Spring Data pagination query params.
   * @param {Array<number>} accountIds
   * @param {number} page zero-based page index
   * @param {number} size page size
   */
  getAccountPlateMatches(accountIds, page = 0, size = 20) {
    return this.adapter.save(
      `lpr/accounts/matches?page=${encodeURIComponent(
        page
      )}&size=${encodeURIComponent(size)}`,
      { accountIds }
    );
  }

  /**
   * Backfill of PENDING vehicle-resident matches for historical LPR events
   * within a decision-at date range. Synchronous; only creates PENDING rows.
   * @param {Object} query expects 'decision-at-start' and 'decision-at-end'
   *                 in ISO 8601 local format (yyyy-MM-ddTHH:mm:ss).
   */
  backfillLprMatches(query) {
    const queryString = Object.keys(query)
      .map(
        key => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`
      )
      .join('&');
    return this.adapter.save(`lpr/matches/backfill?${queryString}`, {});
  }
}

export default new GuardModule('guard', ApiConfig);
